import {gpsControlAllows,gpsControlProfile,validGpsInterval} from './gps-control-profile.js';

// Product choices are deliberately separate from documented firmware limits.
export const GPS_INTERVAL_SECONDS=Object.freeze([
  30,60,120,180,240,300,600,900,1200,1800,
  ...Array.from({length:12},(_,i)=>(i+1)*3600),86400,129600,172800,259200,
]);
const models=new Set(['YG-T11','T11','T12','D3','D3 Pro','T94','YG-T94','T94 Pro','YG-T94 Pro','YG-T94pro','OBD','YG-OBD']);
export const hasYoguIntervalCatalogue=profile=>profile?.protocol==='gt06'&&models.has(profile.model)&&profile.features?.includes('position')===true;

// Resolve complete preset values from the trusted profile. Drive's resting
// value is explicitly zero; it must never inherit D3 Pro's equal-value pair.
export function gpsIntervalPresetValue(profile,value){
  const control=gpsControlProfile(profile?.gpsControl?.id);
  if(!gpsControlAllows(profile,'interval')||control?.intervalUnit!=='seconds')return null;
  const requested=control.timerPair?{accOn:value,accOff:control.intervalPresetAccOff??value}:value;
  return validGpsInterval(requested,control)?requested:null;
}

export function gpsIntervalPresets(profile,action='interval'){
  const control=gpsControlProfile(profile?.gpsControl?.id);
  const allowed=hasYoguIntervalCatalogue(profile)&&['interval','mode'].includes(action)&&gpsControlAllows(profile,action);
  const choices=[...new Set([...GPS_INTERVAL_SECONDS,...(control?.additionalIntervalPresets??[])])].sort((a,b)=>a-b);
  return choices.map(seconds=>{
    const value=action==='mode'?seconds/60:seconds;
    const valid=action==='mode'?Number.isInteger(value)&&value>=control?.modeMin&&value<=control?.modeMax
      :gpsIntervalPresetValue(profile,value)!==null;
    return {seconds,value,enabled:Boolean(allowed&&valid)};
  });
}

// An old request selects a preset only when both stored fields match it.
// Unknown/asymmetric legacy values stay visible in history without being changed.
export function gpsIntervalStoredPreset(profile,request,action='interval'){
  if(!request)return null;
  const seconds=action==='mode'?request.value*60:request.value;
  const choice=gpsIntervalPresets(profile,action).find(c=>c.enabled&&c.seconds===seconds);
  if(!choice)return null;
  const value=action==='mode'?choice.value:gpsIntervalPresetValue(profile,choice.value);
  if(value&&typeof value==='object'&&request.accOff!==value.accOff)return null;
  return choice;
}

export function gpsPresetLabel(seconds,danish){
  if(seconds<60)return `${seconds} ${danish?'sekunder':'seconds'}`;
  if(seconds<3600){const n=seconds/60;return `${n} ${danish?(n===1?'minut':'minutter'):(n===1?'minute':'minutes')}`;}
  const n=seconds/3600;return `${n} ${danish?(n===1?'time':'timer'):(n===1?'hour':'hours')}`;
}
